// extracted by mini-css-extract-plugin
export default {"passwordAttribute":"mD2vp7XpcO7z1nIZ4NTn","fail":"dy8me89878B01TeWAmmw"};